import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import '@telus-uds/palette-allium/build/rn/fonts/fonts.css';
// import './assets/css/main.css';
import './assets/sass/main.scss';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
